import {PageHeader} from "@ant-design/pro-layout";
import {getImageLink, navigateBackHandler} from "../../../helpers/mainHelpers";
import {Empty, Spin} from "antd";
import "./style.less"
import StaffList from "../../../components/staff-list/StaffList";
import AddActionButton from "../../../components/action-buttons/addAction-button/AddActionButton";
import Gallery from "../../../components/galerry/Gallery";
import {useParams} from "react-router-dom";
import {useDepartmentController} from "../../../controllers/departments-controller";
import React, {useEffect, useMemo} from "react";
import * as BUCKETS from "../../../enums/buckets"
import {useStaffController} from "../../../controllers/staff-controller";
import OfficesList from "./components/offices-list/OfficesList";
import {useOfficeController} from "../../../controllers/office-controller";
import {useAuth} from "../../../context/authContext";
import TextReader from "../../../components/text-reader/TextReader";
import ScrollToTopButton from "../../../components/main-buttons/scroll-button/ScrollToTopButton";
import {Query} from "appwrite";
import {CameraOutlined, EnvironmentOutlined, MedicineBoxOutlined, TeamOutlined} from "@ant-design/icons";


const DepartmentPage = () => {
  const {departmentId} = useParams()
  const {isLoading, getDepartmentItemById, selectedDepartment} = useDepartmentController()
  const staffController = useStaffController()
  const {lastUpdate, fetchStaffList} = staffController
  const officesController = useOfficeController()
  const {canManageContent} = useAuth()

  useEffect(() => {
    if (departmentId) {
      // get department data
      getDepartmentItemById(departmentId)
    }
  }, [departmentId])

  useEffect(() => {
    if (departmentId) {
      // Get department staff
      const queries = [Query.equal("department", departmentId || ""), Query.isNull("offices")]
      fetchStaffList(queries)
    }
  }, [lastUpdate, departmentId])

  const galleryImages = useMemo(() => {
    if (selectedDepartment?.images.length) {
      return selectedDepartment.images.filter((imageId) => {
        return imageId !== selectedDepartment?.mainImage
      }).map((imageId) => getImageLink({imageId: imageId, bucketId: BUCKETS.MAIN}))
    }
    return []
  }, [selectedDepartment])


  const addStaffButtonHandler = () => {
    staffController.toggleCreateModal({selectedStaff: undefined, isModalOpen: true})
  }

  const addOfficeButtonHandler = () => {
    officesController.toggleCreateModalVisible()
  }

  return (<>
    <div className="page_title department-page__navigation">
      <PageHeader
        title={
          <div className="page-header_title">
            <div className="page_name">{selectedDepartment?.name}</div>
          </div>
        }
        onBack={navigateBackHandler}
      />
    </div>
    <div className="page_content department-page__content">
      <Spin spinning={isLoading}>
        {selectedDepartment ? <main className="department-page">
          <section className="department-hero" aria-labelledby="department-title">
            <div className="department-hero__media">
              {selectedDepartment.mainImage
                ? <img className="department-hero__image"
                       src={getImageLink({imageId: selectedDepartment.mainImage, bucketId: BUCKETS.MAIN})}
                       alt={selectedDepartment.name}/>
                : <div className="department-hero__placeholder" aria-hidden="true"><MedicineBoxOutlined/></div>}
            </div>
            <div className="department-hero__content">
              <div className="department-hero__eyebrow"><MedicineBoxOutlined/> Відділення лікарні</div>
              <h1 className="department-hero__title" id="department-title">{selectedDepartment.name}</h1>
              <div className="department-hero__about"><TextReader value={selectedDepartment.about}/></div>
            </div>
          </section>

          {selectedDepartment?.departmentContainOffices ?
            <section className="department-section department-page__offices" aria-labelledby="offices-title">
              <header className="department-section__header">
                <div>
                  <div className="department-section__eyebrow"><EnvironmentOutlined/> Підрозділи</div>
                  <h2 className="department-section__title" id="offices-title">Амбулаторії та кабінети</h2>
                </div>
                {canManageContent && <AddActionButton onClick={addOfficeButtonHandler} size="small"/>}
              </header>
              <OfficesList officesController={officesController}/>
            </section> : null
          }
          {staffController.staffList.length ? <section className="department-section department-page__staff" aria-labelledby="staff-title">
            <header className="department-section__header">
              <div>
                <div className="department-section__eyebrow"><TeamOutlined/> Команда</div>
                <h2 className="department-section__title" id="staff-title">Лікарі відділення</h2>
              </div>
              {canManageContent && <AddActionButton onClick={addStaffButtonHandler} size="small"/>}
            </header>
            <StaffList staffController={staffController}/>
          </section> : null}
          {galleryImages?.length ?
            <section className="department-section department-page__gallery" aria-labelledby="gallery-title">
              <header className="department-section__header">
                <div>
                  <div className="department-section__eyebrow"><CameraOutlined/> Простір відділення</div>
                  <h2 className="department-section__title" id="gallery-title">Фотогалерея</h2>
                </div>
              </header>
              <Gallery images={galleryImages}/>
            </section> : null
          }
        </main> : !isLoading && <div className="department-page__empty"><Empty description="Відділення не знайдено"/></div>}
      </Spin>
      <ScrollToTopButton elementSelector={".page_content"}/>
    </div>
  </>)
}

export default DepartmentPage
